/**
 * Object to holds constants for the site to prevent the use of magic strings.
 */
var constants = {

  responseParentType: {
    none: 'None',
    request: 'Request',
    appeal: 'Appeal'
  }
};

export default constants;
